/**
 * 橘子物联定制设备相关接口api（包括通讯设备/虚拟设备）
 */
import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 添加通讯设备(橘子物联定制)
	 * @param {String} name = [设备名称] 
	 * @param {String} deviceGroup = [设备模板组名称] 
	 * @param {String} deviceTemplate = [设备模板名称] 
	 * @param {String} deviceSubseries = [设备子系列名称] 
	 * @param {String} code = [客户编号，由橘子物联提供] 
	 * @param {String} password = [客户密码，由橘子物联提供] 
	 * @param {String} qrcode = [设备二维码字符串，由橘子物联提供] 
	 * @param {String} sn = [设备sn号，由橘子物联提供]
	 * @param {String} channelNo = [设备对应通道no：不指定的话，接口会查询当前连接采集平台对应的通道no]
	 * @param {String} groupNo = [虚拟设备组no：不指定的话，接口就不会给添加的通讯设备添加对应的虚拟设备]
	 */
	addDeviceForOrangeWulian: (name, deviceGroup, deviceTemplate, deviceSubseries, code, password, qrcode, sn, channelNo, groupNo, success, failure) => {
		Axios.post('/orangeWulian/addDeviceForOrangeWulian.do', {
			name,
			deviceGroup,
			deviceTemplate,
			deviceSubseries,
			code,
			password,
			qrcode,
			sn,
			channelNo,
			groupNo,
		}, success, failure);
	},
	/**
	 * 修改设备相关(橘子物联定制)
	 * @param {String} no = [虚拟设备no] 
	 * @param {String} name = [设备名称] 
	 * @param {String} code = [客户编号，由橘子物联提供] 
	 * @param {String} password = [客户密码，由橘子物联提供] 
	 * @param {String} qrcode = [设备二维码字符串，由橘子物联提供] 
	 * @param {String} sn = [设备sn号，由橘子物联提供]
	 */
	updateDeviceForOrangeWulian: (no, name, code, password, qrcode, sn, success, failure) => {
		Axios.post('/orangeWulian/updateDeviceForOrangeWulian.do', {
			no,
			name,
			code,
			password,
			qrcode,
			sn,
		}, success, failure);
	},
	/**
	 * 删除设备相关(橘子物联定制)
	 * @param {String} no = [虚拟设备no] 
	 */
	deleteDeviceForOrangeWulian: (no, success, failure) => {
		Axios.post('/orangeWulian/deleteDeviceForOrangeWulian.do', {
			no,
		}, success, failure);
	},

}